import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function LogoutDialog({ setLoginStatus, loginStatus, setAutoLogoutStatus, autoLogoutStatus, launchLogin }) {

  return (
    <div>
      <Dialog
        open={autoLogoutStatus}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Dein Login ist abgelaufen."}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Möchtest du dich neu einloggen?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setAutoLogoutStatus(false); }} color="primary">
            Abbrechen
          </Button>
          <Button onClick={() => { setAutoLogoutStatus(false); launchLogin(setLoginStatus, loginStatus) }} color="primary" autoFocus>
            Login
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default LogoutDialog
